<template>
  <div id="blue-cross">
    <blue-header></blue-header>
    <blue-banner></blue-banner>
    <long-video></long-video>
    <service-product></service-product>
    <short-video></short-video>
    <blue-consultation></blue-consultation>
    <blue-footer></blue-footer>
  </div>
</template>

<script>
import BlueHeader from "../components/blueCross/home/blueHeader/Index";
import BlueBanner from "../components/blueCross/home/blueBanner/Index";
import LongVideo from "../components/blueCross/home/longVideo/Index";
import ServiceProduct from "../components/blueCross/home/serviceProduct/Index";
import ShortVideo from "../components/blueCross/home/shortVideo/Index";
import BlueConsultation from "../components/blueCross/home/blueConsultation/Index";
import BlueFooter from "../components/blueCross/home/blueFooter/Index";
export default {
  name: "blueCross",
  components: {
    BlueHeader,
    BlueBanner,
    LongVideo,
    ServiceProduct,
    ShortVideo,
    BlueConsultation,
    BlueFooter
  }
};
</script>

<style lang="scss" scoped>
#blue-cross {
  /*text-align: center;*/
  background: #FAFAFA;
}
</style>
